import { defineMessages } from "react-intl";

const messages = defineMessages({
    back: {
        id: "general.back",
    },
});

export default messages;
